import { Screen } from "../scripts/helper";

Cm.columnService = {
    init: function() {
        var adjustScreen = function() {
            $('.element-services-item').each( function() {
                var w = $(this).innerWidth() - 39;
                if(Screen.width() >= 900)
                    $(this).css('height', w+'px');
                else
                    $(this).css('height', '210px');
            });
        };

        $(window).bind('resize', adjustScreen);

        setTimeout(adjustScreen, 100);
    },
};